import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
gsap.registerPlugin(MorphSVGPlugin)

/**
 * Cursor functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class Cursor {
/**
   * Constructs a new Cursor instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */

  constructor(options) {
    this.element = options.element
    this.linkItems = document.querySelectorAll('a, .cursor-link, .swiper-pagination-bullet')
    this.mainNav = document.querySelector('[data-component="main-nav"]')
    this.mainNavItems = this.mainNav.querySelectorAll('.container nav ul li a')

    gsap.set(this.element, { xPercent: -50, yPercent: -50 })

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
    const mouse = { x: pos.x, y: pos.y }
    const speed = 0.35

    const xSet = gsap.quickSetter(this.element, "x", "px")
    const ySet = gsap.quickSetter(this.element, "y", "px")

    window.addEventListener("mousemove", e => {
      mouse.x = e.x
      mouse.y = e.y
      gsap.set(this.element, { autoAlpha: 1 })
    })

    gsap.ticker.add(() => {
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio())
      pos.x += (mouse.x - pos.x) * dt
      pos.y += (mouse.y - pos.y) * dt
      xSet(pos.x)
      ySet(pos.y)
    })

    this.linkItems.forEach(item => {
      item.addEventListener('mouseenter', e => {
        this.element.classList.add('active')
      })
      item.addEventListener('mouseleave', e => {
        this.element.classList.remove('active')
      })
    })
  }
}
